export default __webpack_public_path__ + "static/media/bowtie.874151ab.mp4";